import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const modelNumbersAdapter = createEntityAdapter({})

const initialState = modelNumbersAdapter.getInitialState()

export const modelNumberApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getModelNumbers: builder.query({
            query: () => ({
                url: '/modelnumber',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedmodelnumber = responseData.map(modelnumber => {
                    modelnumber.id = modelnumber._id
                    return modelnumber
                });
                return modelNumbersAdapter.setAll(initialState, loadedmodelnumber)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'MODELNUMBER', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'MODELNUMBER', id }))
                    ]
                } else return [{ type: 'MODELNUMBER', id: 'LIST' }]
            }
        }),
        addNewModelNumber: builder.mutation({
            query: initialUserData => ({
                url: '/modelnumber',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'MODELNUMBER', id: "LIST" }
            ]
        }),
        updateModelNumber: builder.mutation({
            query: initialUserData => ({
                url: '/modelnumber',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'MODELNUMBER', id: arg.id }
            ]
        }),        
        deleteModelNumber: builder.mutation({
            query: ({ id }) => ({
                url: `/modelnumber`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'MODELNUMBER', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetModelNumbersQuery,
    useAddNewModelNumberMutation,
    useUpdateModelNumberMutation,
    useDeleteModelNumberMutation,
} = modelNumberApiSlice

// returns the query result object
export const selectModelNumbersResult = modelNumberApiSlice.endpoints.getModelNumbers.select()

// creates memoized selector
const selectModelNumbersData = createSelector(
    selectModelNumbersResult,
    modelNumbersResult => modelNumbersResult.data // normalized state object with ids & entities
)

// getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllModelNumbers,
    selectById: selectModelNumberById,
    selectIds: selectModelNumberIds
    // Pass in a selector that returns the users slice of state
} = modelNumbersAdapter.getSelectors(state => selectModelNumbersData(state) ?? initialState)
